import { ReactElement } from 'react'

import { MenuItems } from '../../constants/MenuItems'
import { SidebarMobileMenuItem } from './SidebarMobileMenuItem'

export const SidebarMobileListItems = (): ReactElement => {
  return (
    <ol className="flex w-full items-center justify-around gap-2 rounded-full p-1">
      {MenuItems.filter((item) => item.visibleMobile).map((item) => (
        <SidebarMobileMenuItem key={item.id} item={item} />
      ))}
    </ol>
  )
}
